import React from "react";
import { PAGES, LEGAL_APPROVED } from "@/content/legal";
import { usePageMeta } from "@/lib/usePageMeta";

// URLs and email addresses inside the text become links; everything else stays plain text.
const LINK_CLASS = "text-primary underline underline-offset-4 [overflow-wrap:anywhere]";
const withLinks = (text) => text.split(/(https:\/\/\S+?(?=[\s,.)]*(?:\s|$))|[\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g).map((part, i) =>
  /^https:\/\//.test(part)
    ? <a key={i} href={part} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>{part}</a>
    : /@/.test(part) && !/\s/.test(part)
      ? <a key={i} href={`mailto:${part}`} className={LINK_CLASS}>{part}</a>
      : part);

/** About, Contact, Privacy and Terms, from src/content/legal.js. */
export default function InfoPage({ page }) {
  const content = PAGES[page];
  // Draft text stays out of search results until the owner approves it.
  usePageMeta({ title: content.title, description: content.sections[0].body[0], noindex: !LEGAL_APPROVED });
  return (
    <article className="mx-auto max-w-3xl px-4 sm:px-6 py-10" data-testid={`info-${page}`}>
      {!LEGAL_APPROVED && (
        <p role="note" className="mb-6 rounded-[var(--radius)] border border-accent bg-accent/10 px-4 py-3 text-sm">
          Draft: this text has not been approved yet, and bracketed items are placeholders.
        </p>
      )}
      <h1 className="text-[2rem] sm:text-[2.6rem] shirorekha pb-3">{content.title}</h1>
      {content.updated && <p className="mt-2 text-sm text-muted-foreground">Last updated: {content.updated}</p>}
      <div className="mt-6 space-y-8">
        {content.sections.map((s, i) => (
          <section key={i} className="space-y-3">
            {s.heading && <h2 className="text-[1.4rem]">{s.heading}</h2>}
            {s.body.map((p, j) => <p key={j} className="reading">{withLinks(p)}</p>)}
          </section>
        ))}
      </div>
    </article>
  );
}
